import { Box, Tab } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledCustomerTab = styled(Tab)(
   ({ customerUuid, activeCustomerUuid }: { customerUuid: string; activeCustomerUuid: string }) => ({
      minWidth: '100%',
      backgroundColor: customerUuid === activeCustomerUuid ? 'rgba(228,238,247,255)' : 'transparent',
      lineBreak: 'loose',
      fontSize: 13,
      color: customerUuid === activeCustomerUuid ? 'main' : 'grayText',
      '&:hover': {
         color: 'primary',
         backgroundColor: '#E4EEF7',
      },
   })
)

export const TabContainer = styled(Box)(({ theme }) => ({
   display: 'flex',
   justifyContent: 'space-between',
   flexDirection: 'column',
   paddingBottom: 15,
   paddingLeft: 30,
   paddingRight: 30,
   [theme.breakpoints.down('lg')]: {
      paddingLeft: 15,
      paddingRight: 15,
   },
   minHeight: 400,
}))

export default StyledCustomerTab
